export default __webpack_public_path__ + "static/media/add-port.a91f3abf.svg";